import ddt from '@wix/da-ddt';
export var GallectionType = /*#__PURE__*/ function(GallectionType) {
    GallectionType["GALLERY"] = "gallery";
    GallectionType["COLLECTION"] = "collection";
    GallectionType["PRIVATE_COLLECTION"] = "private_collection";
    GallectionType["STASH"] = "stash";
    return GallectionType;
}({});
export var GallectionResourceType = /*#__PURE__*/ function(GallectionResourceType) {
    GallectionResourceType[GallectionResourceType["GALLERY"] = 20] = "GALLERY";
    GallectionResourceType[GallectionResourceType["COLLECTION"] = 21] = "COLLECTION";
    GallectionResourceType[GallectionResourceType["PRIVATE_COLLECTION"] = 88] = "PRIVATE_COLLECTION";
    GallectionResourceType[GallectionResourceType["STASH"] = 59] = "STASH";
    return GallectionResourceType;
}({});
export function gallectionTypeToResourceType(// accomodate type being defined as a plain string in PapiGallection
typeString) {
    switch(typeString){
        case "gallery":
            return 20;
        case "collection":
            return 21;
        case "private_collection":
            return 88;
        case "stash":
            return 59;
        default:
            ddt.error(`unknown GallectionType: ${typeString}`);
            return undefined;
    }
}
export var PremiumFolderType = /*#__PURE__*/ function(PremiumFolderType) {
    PremiumFolderType["Watchers"] = "watchers";
    PremiumFolderType["Paid"] = "paid";
    return PremiumFolderType;
}({});

//# sourceMappingURL=gallection.js.map